<template>
  <div class="flex w-72 flex-col gap-4 px-4 py-3">
    <UiComboboxMultiVee
      name="translationLanguageCodes"
      :label="$t('W: Sprog')"
      :modelValue="selectedLanguageCodes"
      :options="languageOptions"
      :placeholder="$t('W: Alle sprog')"
      :searchPlaceholder="$t('term.search')"
      :emptyText="$t('W: Ingen resultater')"
      @update:model-value="onLanguageCodesChange" />

    <div class="flex items-center justify-between gap-8">
      <span class="text-sm">{{ $t('W: Vis kun manglende oversættelser') }}</span>
      <button
        type="button"
        role="switch"
        :aria-checked="onlyShowMissing"
        aria-label="Vis kun manglende oversættelser"
        class="relative inline-flex h-5 w-9 shrink-0 cursor-pointer rounded-full transition-colors duration-200"
        :class="onlyShowMissing ? '' : 'bg-border-subtle'"
        :style="onlyShowMissing ? 'background-color: var(--color-action)' : ''"
        @click="onToggleOnlyShowMissing">
        <span
          class="pointer-events-none mt-0.5 inline-block h-4 w-4 transform rounded-full bg-white shadow-sm transition-transform duration-200"
          :class="onlyShowMissing ? 'translate-x-4' : 'translate-x-0.5'" />
      </button>
    </div>

    <div class="flex items-center border-t border-border-subtle pt-3">
      <button
        type="button"
        class="cursor-pointer text-sm text-action disabled:cursor-not-allowed disabled:opacity-40"
        :disabled="!hasActiveTranslationFilters"
        @click="onClearClick">
        {{ $t('W: Ryd filtre') }}
      </button>
    </div>
  </div>
</template>

<script lang="ts">
import { mapActions, mapState } from 'pinia'
import { useLabTranslationStore } from '@/stores/labTranslationStore'

export default {
  name: 'LabTranslationsFilterMenu',

  emits: ['close'],

  props: {
    languageOptions: {
      type: Array as () => { value: string; text: string }[],
      required: true,
    },
  },

  computed: {
    ...mapState(useLabTranslationStore, [
      'selectedLanguageCodes',
      'onlyShowMissing',
      'hasActiveTranslationFilters',
    ]),
  },

  methods: {
    ...mapActions(useLabTranslationStore, [
      'setSelectedLanguageCodes',
      'setOnlyShowMissing',
      'clearTranslationFilters',
    ]),

    onLanguageCodesChange(codes: string[]): void {
      this.setSelectedLanguageCodes(codes)
    },

    onToggleOnlyShowMissing(): void {
      this.setOnlyShowMissing(!this.onlyShowMissing)
    },

    onClearClick(): void {
      this.clearTranslationFilters()
    },
  },
}
</script>
